import api from 'api';

export const loadDataTable = api('GET /api/labels/grid');
export const loadModel = api('GET /api/labels/:id');
export const createModel = api('POST /api/labels');
export const updateModel = api('PUT /api/labels/:id');
export const deleteModel = api('DELETE /api/labels/:id');
